module.exports = __webpack_public_path__ + "img/FourierSquare.32a1c0a1.gif";